<template>
	<v-dialog v-model="dialogModel" persistent max-width="500px">
		<v-card>
			<v-card-title class="text-h6">
				{{ $t("UpdateAlignment") }}
			</v-card-title>
			<v-card-text>
				<p>{{ $t("UpdateAlignmentDescription") }}</p>
				<v-radio-group v-model="selectedOption" hide-details class="mt-4">
					<v-radio :label="$t('TangentAlignment')" value="tangent"></v-radio>
					<v-radio :label="$t('SimpleCurveAlignment')" value="simple-circular"></v-radio>
				</v-radio-group>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" variant="text" @click="close">
					{{ $t("CANCEL") }}
				</v-btn>
				<v-btn color="primary" variant="text" @click="submit">
					{{ $t("OK") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true,
	},
});

const emit = defineEmits(["update:modelValue", "close", "submit"]);

const selectedOption = ref("default");

const dialogModel = computed({
	get: () => props.modelValue,
	set: (value) => emit("update:modelValue", value),
});

const close = () => {
	emit("close");
	dialogModel.value = false;
};

const submit = () => {
	emit("submit", selectedOption.value);
	dialogModel.value = false;
};
</script>

<style scoped></style>